import { getLiteral } from 'utils/getLiteral';

export const ONLY_SELECTED_TYPE_FILTER_ID = 'OnlySelectedType';

export const isOnlySelectedTypeActive = (value) => value === '1' || value === '2';

export const getOnlySelectedTypeFilterSchema = () => ({
    id: ONLY_SELECTED_TYPE_FILTER_ID,
    dataType: 'bool',
    description: getLiteral('label_show_selected'),
    isPinnable: false,
    isRemovable: false,
    inputAttrs: {
        options: [
            { label: getLiteral('label_all'), value: '0' },
            { label: getLiteral('common_yes'), value: '1' },
            { label: getLiteral('common_no'), value: '2' },
        ],
    },
});
